<section class="bg-primary bg-[url('/assets/img/theme-bg.webp')]">
  <div
    class="flex flex-col items-center pt-20 px-4 pb-14 mx-auto my-0 max-w-screen-lg"
  >
    <app-section-header
      i18n-header
      i18n-description
      [isLight]="true"
      header="Who are we?"
      description="Skillz vzw has been active since 2017 and has since given thousands of children and young people a camp, after-school education, or workshop. "
    />
    <div
      class="w-full flex gap-6 justify-between items-center flex-col md:flex-row md:items-stretch"
    >
      <app-about-info
        i18n-header
        i18n-description
        class="sm:w-2/3 md:w-1/3"
        header="STEAM"
        description="On a mission through Flanders with our STEAM subjects (Science, Technology, Engineering, Arts, Mathematics). Something for everyone!"
        icon="interests"
        icon-bg-color="primary"
      />
      <!-- TODO Readd: [link]="{ text: 'See the map', url: '/courses?view=map' }" when the map catalogue is implemented -->
      <app-about-info
        i18n-header
        i18n-description
        class="sm:w-2/3 md:w-1/3"
        header="Across (almost) all of Flanders"
        description="From Hasselt to Lokeren, and from Turnhout to Overijse, you will most likely find us at a location near you. If not with a camp, then perhaps with an after-school education or workshop!"
        icon="location_on"
        icon-bg-color="secondary"
      />
      <app-about-info
        i18n-header
        i18n-description
        class="sm:w-2/3 md:w-1/3"
        header="For kids & teens"
        description="Kids and teens from 8 to 14 years old are welcome at our camps. "
        icon="family_restroom"
        icon-bg-color="accent"
      />
    </div>
  </div>
</section>
